export class Reference {
  type: string;
  referenceNo: string;
  segmentNo: string;
  constructor() {
  }
}
